import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from './ThemeContext';

const PageHeader = ({ heading, context, icon }) => {
  const { theme } = useTheme();
  
  return (
    <div className="bg-gradient-to-r from-white via-gray-50 to-white rounded-2xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 p-6 mb-6 relative overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-32 h-32 opacity-5 -mr-16 -mt-16">
        <div 
          className="w-full h-full rounded-full"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      <div className="absolute bottom-0 left-0 w-20 h-20 opacity-5 -ml-10 -mb-10">
        <div 
          className="w-full h-full rounded-full"
          style={{ backgroundColor: theme.primary }}
        ></div>
      </div>
      
      {/* Content */}
      <div className="relative z-0">
        <div className="flex items-center gap-3 mb-3">
          <div 
            className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center shadow-md text-white flex-shrink-0"
            style={{ 
              background: `linear-gradient(135deg, ${theme.primary}, ${theme.primary}dd, ${theme.primary}bb)`,
              minWidth: '2rem',
              minHeight: '2rem'
            }}
          >
            {icon ? (
              <div className="text-xs sm:text-sm">
                {icon}
              </div>
            ) : (
              <div className="w-3 h-3 sm:w-4 sm:h-4 bg-white rounded-full opacity-80"></div>
            )}
          </div>
          <h1 className="text-xl sm:text-2xl font-bold text-gray-800">
            {heading}
          </h1>
        </div>
        <p className="text-gray-600 leading-relaxed ml-13">
          {context}
        </p>
      </div>
    </div>
  );
};

PageHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  icon: PropTypes.node
};

export default PageHeader;